import SmartLink from '../../lib/includes/components/component.smartlink';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import React from "react";

import { useHistory } from "react-router-dom";

import LogoUrl from './../../assets/img/logo.svg';
import {searchSite} from "../actions";
import {store} from "../../lib/store";

const Header = (props) => {

	const history = useHistory();

	if (!props.general) {
		return null;
	}

	return <header id="header" className={"site-header" + (props.custom.scrolled ? " pinned" : "")}>
		<div className="site-header_main">
			<div className="container container--max">
				<div className="row align-items-center">
					<div className="col-6 col--aside">
						<Link to="/" className="logo">
							<img src={LogoUrl} alt={props.general.title}/>
						</Link>
					</div>

					<div className={"site-navigation" + (props.custom.menu_toggled ? " open" : "")}>


						{props.menu.menus.main_menu &&
							<ul className="nav">
								{props.menu.menus.main_menu.items && props.menu.menus.main_menu.items.map((item, i) => {
									if (item.parent === 0) {
										let children = props.menu.menus.main_menu.items.filter(it => it.parent == item.id);
										if (children.length > 0) {

											let toggled = props.custom.submenu_id === i;

											return <li key={i} className={"nav-item has-children " + item.class}>
												<button aria-expanded={toggled}
														onClick={props.toggleSubMenu.bind(null, (toggled ? -1 : i))}
														className={"nav-link" + (toggled ? " toggled" : "")}>{item.title}</button>
												<div aria-hidden={!toggled}
													 className={"sub-menu" + (toggled ? " show" : "")}

												>
													<div
														className={"container" + (item.class === "mega-menu" ? " container--md" : " container--sm")}>
														<button onClick={props.toggleSubMenu.bind(null, -1)}
																className="sub-menu-back-link">Tillbaka
														</button>
														<div className="sub-menu-content">
															<div className="sub-menu-title">
																<h2><SmartLink url={item.url}>{item.title}</SmartLink>
																</h2>

																{item.description &&
																	<p>{item.description}</p>
																}

																<div className="sub-menu-title-footer">
																	<SmartLink url={item.url}
																			   className={"button button-yellow"}>{item.title}
																		<i className="far fa-fw ml-1 fa-arrow-right"></i></SmartLink>
																</div>
															</div>
															<ul className="nav">
																{children.map((subitem, i) => {

																	let subchildren = props.menu.menus.main_menu.items.filter(it => it.parent == subitem.id);

																	if (subchildren.length > 0) {

																		let subtoggled = props.custom.subchildmenu_id?.indexOf(i) >= 0;

																		return <li key={i}
																				   className="nav-item has-sub">
																			<div className="nav-item-top">
																				<SmartLink className="nav-link"
																						   url={subitem.url}>{subitem.title}</SmartLink>
																				<button
																					className="nav-item-top_button"
																					onClick={props.toggleSubChildMenu.bind(null, i)}
																					aria-expanded={subtoggled ? true : false}>
																					<i className="icon fal fa-plus"></i>
																				</button>
																			</div>
																			<ul className={"sub-nav" + (subtoggled ? " open" : "")}>
																				{subchildren.map((subsubitem, i) => {
																					return <li key={i}
																							   className="sub-nav-item">
																						<SmartLink key={i}
																								   className="sub-nav-link"
																								   url={subsubitem.url}>{subsubitem.title}</SmartLink>
																					</li>
																				})}
																			</ul>
																		</li>
																	} else {
																		return <li key={i} className="nav-item">
																			<SmartLink className="nav-link"
																					   url={subitem.url}
																					   target={subitem.target}>{subitem.title}</SmartLink>
																		</li>
																	}


																})}
															</ul>
														</div>
													</div>
												</div>
											</li>
										} else {
											return <li key={i} className="nav-item">
												<SmartLink className="nav-link"
														   url={item.url}>{item.title}</SmartLink>
											</li>
										}
									}
								})}
							</ul>
						}


						<div className="d-lg-none">
							<hr/>

							{props.menu.menus.top_menu &&

								<ul className="nav nav--sm">
									{props.menu.menus.top_menu.items.filter(item => item.parent == 0).map((item, i) => {
										return <li key={item.id} className="nav-item">
											<SmartLink activeClassName="current" className="nav-link" url={item.url}
													   target={item.target}>{item.title}</SmartLink>
										</li>
									})}
								</ul>

							}

							<form action="/sok" className="mt-5">
								<label className="sr-only">Sök:</label>
								<div className="input input--search">
									<i className="input-icon fal fa-search"></i>
									<input type="text" id="searchInputMobile" placeholder="Sök på lejonfastigheter.se"/>
									<button className="input-button"><i className="fal fa-arrow-right"></i></button>
								</div>
							</form>
						</div>

					</div>

					<div className="col-6 col--aside">
						<ul className="nav nav--top justify-content-end">
							{props.menu.menus.user_menu &&
								<li className="nav-item">
									<button id="usermenuButton" onClick={props.toggleUserMenu} aria-expanded={props.custom.usermenu_toggled}
											className="nav-link nav-link--top"><span
										className="nav-link_text">{props.menu.menus.user_menu.title}</span><i
										className={"nav-link_icon fal fa-fw fa-user-circle"}></i>
									</button>
								</li>
							}
							<li className="nav-item nav-item--divider d-none d-lg-block">
								<button id="searchToggleButton" aria-expanded={props.custom.search_toggled} onClick={props.toggleSearch}
										className="nav-link nav-link--top"><i
									className={"nav-link_icon fal fa-fw fa-" + (props.custom.search_toggled ? "times" : "search")}></i>
									<span className="sr-only">Sök</span></button>
							</li>

							<li className="nav-item nav-item--divider d-lg-none">

								<button onClick={props.toggleMenu}
										className={"nav-link nav-link--top menu-burger " + (props.custom.menu_toggled ? " toggled" : "")}>
									<i className="nav-link_icon fal fa-fw fa-bars"></i>
									<span className="nav-link_text">Meny</span>
								</button>
							</li>


						</ul>
					</div>


				</div>
			</div>
		</div>

		<div aria-hidden={!props.custom.search_toggled}
			 className={"sub-menu" + (props.custom.search_toggled ? " show" : "")}>
			<div className="sub-menu-content">
				<div className="container container--sm">
					<form action="/sok" onSubmit={(e) => {


						e.preventDefault();
						history.push('/sok')
						searchSite();

					}}>
						<label className="sr-only">Sök:</label>
						<div className="input input--search">
							<i className="input-icon fal fa-search"></i>
							<input type="text" id="searchInput" value={props.searchState.searchString}
								   onChange={props.onSearchChange} placeholder="Sök på lejonfastigheter.se"/>
							<button className="input-button"><i className="fal fa-arrow-right"></i></button>
						</div>
					</form>
				</div>
			</div>
		</div>


		<div id="userMenu" tabIndex={-1} aria-hidden={!props.custom.usermenu_toggled}
			 className={"sidebar" + (props.custom.usermenu_toggled ? " show" : "")}>

			<div className="sidebar-content">

				<button id="userMenuCloseButton" onClick={props.toggleUserMenu} className="sidebar-close"><i className="fal fa-times"></i></button>

				<div className="sidebar-top">
					<h2>{props.menu.menus.user_menu.title}</h2>
					{props.general.header.user_intro &&
						<p>{props.general.header.user_intro}</p>
					}

				</div>

				<div className="sidebar-nav">
					<ul className="nav nav--icons">
						{props.menu.menus.user_menu.items.filter(item => item.parent === 0).map((item, i) => {

							let subchildren = props.menu.menus.user_menu.items.filter(it => it.parent === item.id);


							if (item.id === 390) {
								subchildren = [];
								props.buildingState.building_slugs?.forEach(building => {
									subchildren.push({
										title: building.title,
										url: item.url+building.slug
									});
								})

							}

							if (subchildren.length > 0) {

								let subtoggled = props.custom.subchildmenu_id?.indexOf(i) >= 0;

								return <li key={i} className="nav-item has-sub">
									<button
										className="nav-link has-children"
										onClick={props.toggleSubChildMenu.bind(null, i)}
										aria-expanded={subtoggled}>
										<i
											className={"icon fal fa-fw fa-" + item.class}></i>

										{item.title}

									</button>
									<ul className={"nav sub-nav" + (subtoggled ? " open" : "")}>
										{subchildren.map((sub_item, i) => {
											return <li key={i}
													   className="nav-item">
												<SmartLink key={i}
														   className="nav-link"
														   url={sub_item.url}>{sub_item.title}</SmartLink>
											</li>
										})}
										{item.id === 390 && <li className="nav-item nav-item--small"><SmartLink className="nav-link" url={item.url}>Alla fastigheter</SmartLink></li>}
									</ul>
								</li>
							} else {
								return <li key={i} className="nav-item">
									<SmartLink activeClassName="current"
											   className="nav-link"
											   url={item.url} target={item.target}><i
										className={"icon fal fa-fw fa-" + item.class}></i> {item.title}
									</SmartLink>
								</li>
							}


						})}
					</ul>

					<Link to="/kontakt"
						  className="button button-dark" onBlur={props.focusTo.bind(null,'userMenuCloseButton')}>Kontakta
						oss <i className="far fa-fw ml-1 fa-arrow-right"></i></Link>
				</div>
			</div>
			<div onClick={props.toggleUserMenu} className="sidebar-bg"></div>


		</div>


		{(
				props.custom.search_toggled ||
				props.custom.submenu_id > -1
			) &&
			<div className="site-header_bg" onClick={props.hideBackdrop}></div>
		}


	</header>
};
export default connect(
	state => {
		return {
			menu: state.menuState,
			general: state.generalState.general,
			headerStyle: state.pageState.page?.headerStyle,
			custom: state.customState,
			buildingState: state.buildingState,
			searchState: state.searchState
		}
	},
	(dispatch) => {
		return {
			focusTo: (id) => {
				document.getElementById(id).focus();
			},
			toggleMenu: () => {
				dispatch({
					type: 'MENU_TOGGLED'
				})
			},
			toggleSubMenu: (id, e) => {
				e.preventDefault();
				dispatch({
					type: 'SUBMENU_TOGGLED',
					id: id
				})
			},
			toggleSubChildMenu: (id, e) => {
				e.preventDefault();
				dispatch({
					type: 'SUBCHILDMENU_TOGGLED',
					id: id
				})
			},
			toggleUserMenu: () => {

				dispatch({
					type: 'USERMENU_TOGGLED',
				})

				if (store.getState().customState.usermenu_toggled) {
					setTimeout(function () {
						document.getElementById("userMenu").focus();
					}, 300)
				} else {
					document.getElementById("usermenuButton").focus();
				}
			},
			toggleSearch: () => {
				dispatch({
					type: 'SEARCH_TOGGLED',
				})

				if (store.getState().customState.search_toggled) {
					setTimeout(function () {
						document.getElementById("searchInput").focus();
					}, 300)
				} else {
					document.getElementById("searchToggleButton").focus();
				}
			},
			hideBackdrop: () => {
				dispatch({
					type: 'HIDE_BACKDROP'
				})
			},
			onSearchChange: (e) => {
				dispatch({
					type: "SEARCH_CHANGED",
					search: e.target.value
				})
			}
		}
	}
)(Header);
